<template>
    <section class="panel">
        <header class="panel-heading">
            <h2 class="panel-title">Forma de Contacto</h2>
        </header>
        <form @submit.prevent="submit">
            <div class="panel-body">
                <label v-show="isSubmited">Tu mensaje ha sido enviado exitosamente.</label>
                <div class="form-group mb-xl" v-bind:class="{ 'has-error': errors.has('subject') }">
                    <label class="col-md-3 control-label" for="inputDefault">Asunto</label>
                    <div class="col-md-6">
                        <select class="form-control input-lg mb-md"
                                v-model="formData.subject" v-validate="'required'" name="subject">
                            <option>Modificaciones y Bajas</option>
                            <option>Quejas y Sugerencias</option>
                            <option>Soporte</option>
                            <option>Dirección General</option>
                        </select>
                        <label v-show="errors.has('subject')" class="error">{{ errors.first('subject') }}</label>
                    </div>
                </div>
                <div class="form-group mb-xl" v-bind:class="{ 'has-error': errors.has('message') }">
                    <label class="col-md-3 control-label" for="textareaAutosize">Mensaje</label>
                    <div class="col-md-6">
                        <textarea class="form-control" rows="3" name="message"
                                  v-model="formData.message" v-validate="'required'"
                                  data-plugin-textarea-autosize=""
                                  style="overflow: hidden; word-wrap: break-word; resize: none; height: 100px;" />
                        <label v-show="errors.has('message')" class="error">{{ errors.first('message') }}</label>
                    </div>
                </div>
            </div>
            <div class="panel-footer">
                <div class="row">
                    <div class="col-md-9 col-md-offset-3">
                        <button type="submit" class="mb-xs mt-xs mr-xs btn btn-lg btn-primary">
                            Enviar Mensaje
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
    module.exports = {
        name: 'contact-form',
        data: function () {
            return {
                formData : {
                    subject : "",
                    message : ""
                },
                isLoading: true,
                isSubmited: false
            }
        },
        mounted: function(){
            this.$nextTick(function () {
                this.refresh();
            });
        },
        methods: {
            refresh: function () {
                this.isLoading = false;
            },
            submit: function () {
                var self = this;
                self.isSubmited = false;
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.axios.post("/api/contact/submit-request",
                                {
                                    subject: this.formData.subject,
                                    message: this.formData.message
                                }).
                            then(function (response) {
                                console.debug(response.data);
                                self.isSubmited = true;
                                self.isLoading = false;
                            }, function (error) {
                                console.debug(error);
                                self.isLoading = false;
                            });

                        return;
                    }
                });

                
            }
        }
    }
</script>